"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineClaimRequest = void 0;
class OnlineClaimRequest {
}
exports.OnlineClaimRequest = OnlineClaimRequest;
//# sourceMappingURL=OnlineClaimRequest.js.map